import React, { useState } from 'react';
import PrimaryNavigation from '../../components/ui/PrimaryNavigation';
import BreadcrumbNavigation from '../../components/ui/BreadcrumbNavigation';
import UserManagementTable from './components/UserManagementTable';
import ContentModerationPanel from './components/ContentModerationPanel';
import SystemStatisticsPanel from './components/SystemStatisticsPanel';
import PlatformConfigurationPanel from './components/PlatformConfigurationPanel';
import NoticeManagementPanel from './components/NoticeManagementPanel';
import Icon from '../../components/AppIcon';

const AdminDashboard = () => {
  const [activeTab, setActiveTab] = useState('users');

  const tabs = [
    { id: 'users', label: '사용자 관리', icon: 'Users' },
    { id: 'moderation', label: '콘텐츠 관리', icon: 'Shield' },
    { id: 'notices', label: '공지', icon: 'Megaphone' },
    { id: 'statistics', label: '통계', icon: 'BarChart3' },
    { id: 'configuration', label: '설정', icon: 'Settings' },
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'users':
        return <UserManagementTable />;
      case 'moderation':
        return <ContentModerationPanel />;
      case 'notices':
        return <NoticeManagementPanel />;
      case 'statistics':
        return <SystemStatisticsPanel />;
      case 'configuration':
        return <PlatformConfigurationPanel />;
      default:
        return <UserManagementTable />;
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <PrimaryNavigation />
      <BreadcrumbNavigation />
      <main className="pt-32 lg:pt-24 pb-24 lg:pb-8 px-4 lg:px-8">
        <div className="max-w-screen-2xl mx-auto">
          <div className="mb-6 md:mb-8">
            <div className="flex items-center space-x-3 mb-2">
              <div className="w-12 h-12 bg-primary/20 rounded-md flex items-center justify-center">
                <Icon name="Shield" size={24} color="var(--color-primary)" />
              </div>
              <div>
                <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground">
                  관리자 대시보드
                </h1>
                <p className="text-sm md:text-base text-muted-foreground caption mt-1">
                  플랫폼 관리 및 모니터링
                </p>
              </div>
            </div>
          </div>

          <div className="hidden lg:flex items-center space-x-2 mb-6 overflow-x-auto">
            {tabs?.map((tab) => (
              <button
                key={tab?.id}
                onClick={() => setActiveTab(tab?.id)}
                className={`flex items-center space-x-2 px-6 py-3 rounded-md transition-gaming whitespace-nowrap ${
                  activeTab === tab?.id
                    ? 'bg-primary text-primary-foreground shadow-gaming-sm'
                    : 'text-muted-foreground hover:bg-muted hover:text-foreground'
                }`}
              >
                <Icon
                  name={tab?.icon}
                  size={20}
                  color={activeTab === tab?.id ? 'currentColor' : 'currentColor'}
                />
                <span className="font-medium">{tab?.label}</span>
              </button>
            ))}
          </div>

          <div className="lg:hidden mb-6">
            <div className="flex items-center space-x-2 overflow-x-auto pb-2">
              {tabs?.map((tab) => (
                <button
                  key={tab?.id}
                  onClick={() => setActiveTab(tab?.id)}
                  className={`flex flex-col items-center space-y-1 px-4 py-3 rounded-md transition-gaming whitespace-nowrap flex-shrink-0 ${
                    activeTab === tab?.id
                      ? 'bg-primary text-primary-foreground shadow-gaming-sm'
                      : 'text-muted-foreground hover:bg-muted hover:text-foreground'
                  }`}
                >
                  <Icon
                    name={tab?.icon}
                    size={20}
                    color={activeTab === tab?.id ? 'currentColor' : 'currentColor'}
                  />
                  <span className="text-xs font-medium caption">{tab?.label}</span>
                </button>
              ))}
            </div>
          </div>

          <div className="transition-gaming">{renderTabContent()}</div>
        </div>
      </main>
    </div>
  );
};

export default AdminDashboard;